/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import type { ClipAssetResponse } from '../schemas/ClipAssetResponse';
import type { SuggestClip } from '../schemas/SuggestClip';
import { fetcher, FetcherOptions } from './fetcher';

export interface AssetsClipSuggestClipsCreateAPIQueryParams {
  ordering?: string;
}

export type AssetsClipSuggestClipsCreateRequestBody = SuggestClip;

export type AssetsClipSuggestClipsCreateOkResponse = ClipAssetResponse[];

export type AssetsClipSuggestClipsCreateErrorResponse = unknown;

export interface AssetsClipSuggestClipsCreateProps
  extends Omit<
    FetcherOptions<
      AssetsClipSuggestClipsCreateAPIQueryParams,
      AssetsClipSuggestClipsCreateRequestBody
    >,
    'url'
  > {
  queryParams: AssetsClipSuggestClipsCreateAPIQueryParams;
  body: AssetsClipSuggestClipsCreateRequestBody;
}

export function assetsClipSuggestClipsCreate(
  props: AssetsClipSuggestClipsCreateProps
): Promise<AssetsClipSuggestClipsCreateOkResponse> {
  return fetcher<
    AssetsClipSuggestClipsCreateOkResponse,
    AssetsClipSuggestClipsCreateAPIQueryParams,
    AssetsClipSuggestClipsCreateRequestBody
  >({
    url: `/assets/clip/suggest_clips/`,
    method: 'POST',
    ...props
  });
}
